import { Component } from '@angular/core';

@Component({
    selector: 'app-enquiry',
    standalone: true,
    imports: [],
    templateUrl: './enquiry.component.html',
})
export class EnquiryComponent {}
